/**
 * The guest's general age bucket. 4yo or under/Child/Teen/Adult/Senior
 */
export const AGE_BIN = 'AgeBin';

/**
 * The pass name e.g. "Ikon Base Pass" or Ikon Pass
 */
export const DESCRIPTION = 'Description';

/**
 * The ski season this entitlements applies for
 * e.g. "2018-2019"
 */
export const SEASON = 'Season';

/**
 * When the entitlement is going to expire
 */
export const EXPIRATION_DATE = 'ExpirationDate';

/**
 * When the entitlement is effective
 */
export const EFFECTIVE_DATE = 'EffectiveDate';